import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import { MunicipalityRecord } from "../../../../../type/municipalityRecord";
import useAxios from "../../../../../hook/useAxios";
import { toast } from "react-toastify";
import ActionItem from "../../../../Global/ActionItem";
import AddMunicipality from "../AddMunicipality/AddMunicipality";
import WarningRedAlert from "../../../../ErrorAndAlert/WarningRedAlert";

const MunicipalityTableItem: React.FC<{
  municipality: MunicipalityRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ municipality, fetchData: propFetchData, lastIndex }) => {
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDelete, isShowDelete] = useState<boolean>(false);
  const [editData, setEditData] = useState(null);

  const { i18n, t } = useTranslation();
  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/municipalities/${municipality.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.Successful delete")}`,
    true,
    true
  );
  const { fetchData: editMunicipality, response: editResponse } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/municipalities/${municipality.slug}/edit/`,
    "PUT",
    false,
    "",
    true,
    true
  );
  const { fetchData: getMunicipality, response: getEditResponse } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/municipalities/${municipality.slug}/edit/`,
    "GET",
    false,
    "",
    true,
    true
  );

  useEffect(() => {
    if (getEditResponse) {
      setEditData(getEditResponse);
    }
  }, [getEditResponse]);

  useEffect(() => {
    if (editResponse) {
      propFetchData();
      toast.success(t("Message.Successful update"));
      setShowEditModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editResponse]);

  useEffect(() => {
    if (deleteR) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (municipality.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t(
          "Message.You can’t delete the district. It is used in a planting event, workshop or community."
        )
      );
    }
  };

  const editAction = () => {
    getMunicipality({});
    setShowEditModal(true);
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };

  const handleModalClose = () => {
    setShowEditModal(false);
  };

  const active =
    i18n.language === "en"
      ? municipality.is_active_transes.en
      : municipality.is_active_transes.fr;

  return (
    <Fragment>
      <TableCell align="left">{municipality.name}</TableCell>

      <TableCell>
        <p
          className={`${
            municipality.is_active_transes.en === "Active"
              ? "bg-[#CDE6F0] text-[#066993]"
              : "bg-[#FFDBDE] text-[#D2202A]"
          } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>

      <TableCell align="right">
        <ActionItem
          delete={true}
          editAction={editAction}
          deleteAction={deleteAction}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
          isEditModal
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={t("Municipality.Municipality")}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
      {showEditModal && editData && (
        <AddMunicipality
          handleModalClose={handleModalClose}
          send={editMunicipality}
          textButton={t("Tree Species.Update")}
          title={t("Municipality.Edit municipality")}
          getInfo={editData}
        />
      )}
    </Fragment>
  );
};

export default MunicipalityTableItem;
